import { SongList, Header1 } from './component/main_components';
import React, { useState } from 'react';
import AnimatedBackground from './component/AnimatedBackground';
import './App.css';

function App() {
  document.title = "My Music App";
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <div className="App">
      <AnimatedBackground />
      <header>
        <Header1 isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
      </header>
      <main>
        <SongList isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
      </main>
    </div>
  );
}

export default App;